export const COINS_PAGES_DELAY = 40000;
export const CHART_LIGHTWEIGHT_DELAY = 40000;
